import './plugins/vue-axios'
import './plugins/moment'
import './plugins/vue2-siema'
import './plugins/vue-meta'
import './plugins/i18n'
import './plugins/vue-uuid'
import './router/componentHooks'
import './plugins/highcharts'

import App from './App.vue'


import Vue from 'vue'

import router from './router'
import store from '@/store'
import {sync} from 'vuex-router-sync'
import vuetify from './plugins/vuetify'

import i18n from "./helpers/i18n"
import {VueReCaptcha} from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_KEY })

import interceptorsSetup from './helpers/interseptors'

interceptorsSetup()

if (!localStorage.getItem('access-token') || !localStorage.getItem('refresh-token')) {
  localStorage.removeItem('access-token')
  localStorage.removeItem('refresh-token')
} else {
  store.commit('newauth/tokenSetup', {
    'access_token': localStorage.getItem('access-token'),
    'refresh_token': localStorage.getItem('refresh-token'),
  })
}

import barcode from 'tui-vue-barcode'


Vue.component('barcode', barcode)

sync(store, router)

Vue.config.productionTip = false;


/**
 * Базовый URL сервера
 */
import {RECAPTCHA_KEY} from "@/config";



Vue.axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.axios.defaults.headers.get['Content-Type'] = 'application/json';


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
